export const normalizeSFCCLocale = (locale: string): string => {
  return locale.replace('-', '_');
};
